import { Button, Container, Eyebrow, scrollToId } from './primitives'

const SLOTS_TOTAL = 5
const SLOTS_TAKEN = 2

export function Testimonials() {
  const slots = Array.from({ length: SLOTS_TOTAL }, (_, i) => i < SLOTS_TAKEN)
  return (
    <section
      style={{
        padding: '96px 0',
        borderTop: '1px solid var(--line)',
        background: '#F4F1E8',
      }}
    >
      <Container>
        <div
          className="testi-grid"
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: 56,
            alignItems: 'center',
          }}
        >
          <div>
            <Eyebrow>Launch partners</Eyebrow>
            <h2
              style={{
                fontSize: 'clamp(32px, 4vw, 52px)',
                lineHeight: 1.05,
                letterSpacing: '-0.025em',
                fontWeight: 400,
                margin: '20px 0 0',
                fontFamily: 'var(--serif)',
              }}
            >
              Onboarding the first{' '}
              <span style={{ color: 'var(--accent)', fontStyle: 'italic' }}>five</span>{' '}
              customers.
            </h2>
            <p
              style={{
                fontSize: 17,
                lineHeight: 1.55,
                color: 'var(--muted)',
                marginTop: 24,
                maxWidth: 520,
              }}
            >
              Flat <span style={{ color: 'var(--fg)', fontWeight: 500 }}>$1,999</span> for
              the first five launch partners. The only ask: permission to share your site
              and a short quote after launch, with your sign-off.
            </p>
            <div
              style={{
                marginTop: 32,
                display: 'flex',
                gap: 12,
                alignItems: 'center',
                flexWrap: 'wrap',
              }}
            >
              <Button variant="accent" size="lg" onClick={() => scrollToId('pricing')}>
                Claim a launch spot <span style={{ opacity: 0.6 }}>→</span>
              </Button>
              <span
                style={{
                  fontSize: 13,
                  color: 'var(--muted)',
                  fontFamily: 'var(--mono)',
                  letterSpacing: '0.04em',
                }}
              >
                {SLOTS_TOTAL - SLOTS_TAKEN} OF {SLOTS_TOTAL} LEFT
              </span>
            </div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {slots.map((taken, i) => (
              <div
                key={i}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 16,
                  background: taken ? 'rgba(10,10,10,0.04)' : '#fff',
                  border: '1px solid var(--line)',
                  borderRadius: 2,
                  padding: '18px 22px',
                }}
              >
                <span
                  style={{
                    fontFamily: 'var(--mono)',
                    fontSize: 13,
                    color: 'var(--muted)',
                    letterSpacing: '0.08em',
                    width: 32,
                  }}
                >
                  0{i + 1}
                </span>
                <span
                  style={{
                    fontSize: 15,
                    flex: 1,
                    color: taken ? 'var(--muted)' : 'var(--fg)',
                    textDecoration: taken ? 'line-through' : 'none',
                  }}
                >
                  {taken ? 'Claimed' : 'Open'}
                </span>
                <span
                  style={{
                    fontFamily: 'var(--mono)',
                    fontSize: 12,
                    letterSpacing: '0.06em',
                    color: taken ? 'var(--muted)' : 'var(--accent)',
                    textTransform: 'uppercase',
                  }}
                >
                  {taken ? '·' : '$1,999'}
                </span>
              </div>
            ))}
          </div>
        </div>
      </Container>
    </section>
  )
}
